import React, { Component } from 'react';
import { connect } from 'react-redux';

import { dataGroupItemSelected, dataGroupItemUnselect } from 'actions';

import Icon from 'components/common/Icon';
import EventDataGroup from 'components/calendar/EventDataGroup';
import unescape from 'lodash/unescape';
import has from 'lodash/has';
import some from 'lodash/some';
import isEmpty from 'lodash/isEmpty';
import forEach from 'lodash/forEach';

class EventDataGroupItem extends Component {
  constructor(props) {
    super(props);

    // Default expanded is true if I have children selected (otherwise expanded = false)
    this.state = { expanded: props.isChildSelected };
    this.toggleExpanded = this.toggleExpanded.bind(this);
    this.toggleSelected = this.toggleSelected.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.search > '') {
      this.setState({ expanded: true });
    }
    if (isEmpty(nextProps.search) && !isEmpty(this.props.search)) {
      this.setState({ expanded: false });
    }
  }

  get itemText() {
    if(this.props.item.primary_fields.length > 0 && has(this.props.item, 'other') && this.props.item.other.length > 0) {
      return { __html: unescape(this.props.item.primary_fields) + ' <span class="other">' + unescape(this.props.item.other) + '</span>' };
    } else if(this.props.item.primary_fields.length == 0 && has(this.props.item, 'other') && this.props.item.other.length > 0) {
      return { __html: unescape(this.props.item.other) };
    } else {
      return { __html: unescape(this.props.item.primary_fields) };
    }
  }

  toggleExpanded(e) {
    e.stopPropagation();
    this.setState({ expanded: !this.state.expanded });
  }

  toggleSelected(e) {
    e.stopPropagation();
    const { item, section, subsection, parentId, isSelectable, config, search } = this.props;

    if (!isSelectable) {
      return;
    }

    const displayType = isEmpty(search) ? 'browse' : 'search';

    if (!this.props.isSelected) {
      if (section === 'event_types') {
        //can only have 1 event type - so un-select any previous selections
        const { eventDataGroups } = this.props;

        if (has(eventDataGroups, `selected.${section}`)) {
          forEach(eventDataGroups.selected[section], (prevItems, prevSubsection) => {
            if (prevItems) {
              forEach(prevItems, (prevItem) => {
                this.props.dataGroupItemUnselect(section, prevSubsection, prevItem, prevItem.parentId, displayType);
              });
            }
          });
        }
      }
      this.props.dataGroupItemSelected(section, subsection, item, parentId, displayType);
    } else {
      this.props.dataGroupItemUnselect(section, subsection, item, parentId, displayType);
    }
  }

  render() {
    const { item, section, subsection, isSelected, depth, isSelectable, search, config } = this.props;
    const itemClass = isSelected ? 'is-selected' : '';

    const expandIcon =
      this.state.expanded ?
        (<span className="clickable"><Icon icon="arrow" className="rotate-90" /></span>) :
        (<span className="clickable"><Icon icon="arrow" /></span>);

    let iconName = 'location';
    if (section === 'groups') {
      iconName = 'groups';
    } else if (section === 'equipment') {
      iconName = 'equipment';
    } else if (section === 'departments' || section === 'activities' || section === 'event_types') {
      iconName = 'tag';
    }

    if (item.has_children) {
      return (
        <li className={itemClass} onClick={this.toggleExpanded}>
          {depth === 0 && (<Icon icon={iconName} size="xlarge" className="location-icon" />)}

          <span className="clickable row-text" dangerouslySetInnerHTML={this.itemText} />
          {expandIcon}

          {isSelectable && (
            <Icon onClick={this.toggleSelected} icon="checkmark" className="clickable check-icon" />
          )}

          {this.state.expanded && (
            <EventDataGroup parentId={item.id} prefixedParentId={item.prefixedId} section={section} subsection={subsection} config={config} depth={depth + 1} search={search} />
          )}
        </li>
      );
    }

    return (
      <li className={itemClass} onClick={this.toggleSelected}>
        {depth === 0 && (<Icon icon={iconName} size="xlarge" className="location-icon" />)}
        <span className="clickable" dangerouslySetInnerHTML={this.itemText} />

        {isSelectable && (
          <Icon icon="checkmark" className="clickable check-icon" />
        )}
      </li>
    );
  }
}

const calcIsSelected = (eventDataGroups, section, subsection, item, parentId, displayType) => {
  if ( has(item, 'subsection') && (has(eventDataGroups, `selected.${section}.${item.subsection}.${item.prefixedId}`) || has(eventDataGroups, `selected.${section}.${subsection}.${item.prefixedId}`)) ) {
    return true;
  } else if (has(eventDataGroups, `selected.${section}.${subsection}.${item.prefixedId}`)) {
    return true;
  }

  const stateToUse = (displayType == 'search') ? eventDataGroups.search : eventDataGroups;

  if (parentId && has(stateToUse, `${section}.${subsection}.all.${parentId}`)) {
    const parent = stateToUse[section][subsection].all[parentId];
    return calcIsSelected(eventDataGroups, section, subsection, parent, parent.parentId, displayType);
  }

  return false;
};

const calcIsChildSelected = (eventDataGroups, section, subsection, item, displayType) => {
  const stateToUse = (displayType == 'search') ? eventDataGroups.search : eventDataGroups;

  if (item.has_children) {
    if ( has(item, 'subsection') && has(stateToUse, `${section}.${item.subsection}.${item.prefixedId}.lines`) ) {
      return some(stateToUse[section][item.subsection][item.prefixedId].lines, (value =>
        calcIsSelected(eventDataGroups, section, subsection, value, item.prefixedId, displayType) ||
        calcIsChildSelected(eventDataGroups, section, subsection, value, displayType)
      ));
    } else if ( has(stateToUse, `${section}.${subsection}.${item.prefixedId}.lines`) ) {
      return some(stateToUse[section][subsection][item.prefixedId].lines, (value =>
        calcIsSelected(eventDataGroups, section, subsection, value, item.prefixedId, displayType) ||
        calcIsChildSelected(eventDataGroups, section, subsection, value, displayType)
      ));
    }
  }
  return false;
};

function mapStateToProps(state, ownProps) {
  const { eventDataGroups } = state;
  const { section, subsection, item, parentId, search, config } = ownProps;

  const displayType = isEmpty(search) ? 'browse' : 'search';

  return {
    isSelected: calcIsSelected(eventDataGroups, section, subsection, item, parentId, displayType),
    isChildSelected: !isEmpty(search) || calcIsChildSelected(eventDataGroups, section, subsection, item, displayType),
    eventDataGroups,
  };
}

export default connect(mapStateToProps, {
  dataGroupItemSelected,
  dataGroupItemUnselect,
})(EventDataGroupItem);



// WEBPACK FOOTER //
// ./src/app/components/calendar/EventDataGroupItem.js